import { EventEmitter, Injectable, OnInit } from "@angular/core";

import { CookieService } from "ngx-cookie-service";
import { appService } from "../../../app/_services/app.service";
import { ToastrService } from "ngx-toastr";
import { TabHeadingDirective } from "ngx-bootstrap";
import { NavService } from "../../_services/NavService.service";
import { BookingComponent } from "../Booking/booking.component";
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';
declare var $: any;

@Injectable()
export class DashboardService implements OnInit {
  changePage = new EventEmitter();
  CompanyId: any;
  id: any;
  origin: any;
  destination: any;
  datatable;
  TrackLat: any;
  TrackLng: any;
  TrackMobile: any;
  MarkAsAssignList: any = [];
  OrderListDest: any = [];
  fcnumber: any;
  fromcity: any;
  tocity: any;
  vehicletype: any;
  flag: boolean = false;
  isDisplayLiveLocation = 0;

  ListOfAll: any = []; //object for storing all vehicle list
  //Origin Vehicle Lists Array[]
  AssignVehicleList: any = []; // Object  for storing list in array
  ECPickupList: any = [];
  GateInVehicleList: any = []; //object For storing list in array
  ReadyToDispatchList: any = []; //object For storing list in array
  DispatchVehicleList: any = []; //object For storing list in array
  EWayBillVehicleList: any = []; //object For storing list in array
  NewBooking: any = [];
  //ends here

  //Destination Vehicle List Arrya[]
  PendingArrivalList: any = [];
  DestinationGatedIn: any = [];
  DestinationGatedOut: any = [];
  ConfrimDelivery: any = [];
  CompletedList: any = [];
  //ends here

  FromDate: any;
  ToDate: any;
  param1: string = "0";
  param2;
  userId: any;
  constructor(
    private _appService: appService,
    private cookieService: CookieService,
    private toastr: ToastrService,
    private _navService: NavService,
    private decryptpipe: DecryptPipe
  ) {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.GetListOfNewBooking();
    setTimeout(() => {
      this._navService.navItem$.subscribe((item) => {
        if (this.CompanyId != JSON.parse(localStorage.getItem("ChnageCompnayId")).Id) {
          this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
          if (this.NewBooking != []) {
            this.GetListOfNewBooking();
          }
          if (this.ECPickupList != []) {
            this.GetListOfECPickUp();
          }
          if (this.AssignVehicleList != []) {
            this.GetAssignedVehicleData();
          }
          if (this.GateInVehicleList != []) {
            this.GetGateInVehicleList();
          }
          if (this.ReadyToDispatchList != []) {
            this.GetReadyToDispatchVehicleList();
          }
          if (this.DispatchVehicleList != []) {
            this.GetDispatchedVehicleList();
          }
          if (this.EWayBillVehicleList != []) {
            this.GetEWayBillVehicleList();
          }
          if (this.PendingArrivalList != []) {
            this.GetListOfPendingArrival();
          }
          if (this.DestinationGatedIn != []) {
            this.GetListOfDestinationGateIn();
          }
          if (this.DestinationGatedOut != []) {
            this.GetListOfDestinationGatedOut();
          }
          if (this.ConfrimDelivery != []) {
            this.GetListOfConfirmDelivery();
          }
          if (this.CompletedList != []) {
            this.GetListOfCompleted();
          }
        }
      });
    }, 500);
  }

  //Added by pawan darji on 20 feb 2020
  //Created For Clearing Array List To prevent Duplicate list on Dashboard
  clearData() {
    //Origin Vehicle List Arrya[]
    this.ListOfAll = [];
    this.NewBooking = [];
    this.ECPickupList = [];
    this.AssignVehicleList = [];
    this.GateInVehicleList = [];
    this.ReadyToDispatchList = [];
    this.DispatchVehicleList = [];
    this.EWayBillVehicleList = [];
    //Destination Vehicle List Arrya[]
    this.PendingArrivalList = [];
    this.DestinationGatedIn = [];
    this.DestinationGatedOut = [];
    this.ConfrimDelivery = [];
    this.CompletedList = [];
  }

  ngOnInit() { }

  //Getting List Of New Booking List           Created By Pawajn Darji on 30/1/2020
  GetListOfNewBooking() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfNewBooking",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.NewBooking.push(...response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  GetListOfECPickUp() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfECPickUp",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.ECPickupList.push(...response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }

  //created for getting list of assigned vehicle   Created By Pawan Darji on 20/1/2020
  GetAssignedVehicleData() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfAssignedVehical",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.AssignVehicleList.push(...response);
            //console.log('from service', response);
          },
          (err) => {
            this.toastr.error("Error occurred while fetching Data !", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //created for getting list of Gate in vehicle    Created By Pawan Darji on 20/1/2020
  GetGateInVehicleList() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfGateInVehicle",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.GateInVehicleList.push(...response);
            //console.log("GateInList", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching data !", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Created For Getting List of Ready To Dispatch Vehicle    Created By Pawan Darji on 20/1/2020
  GetReadyToDispatchVehicleList() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfReadyToDispatch",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.ReadyToDispatchList.push(...response);
            //console.log("readyToDispatch", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data!", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Created For Getting List of Dispatche Vehicle List      Created By Pawan Darji on 20/1/2020
  GetDispatchedVehicleList() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfDispatchedVehicle",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.DispatchVehicleList.push(...response);
            //console.log("dispatchedVehicleList" , response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data!", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Gettng List of EWay bill Vehicle List  Created By Pawan Darji on 20/1/2020
  GetEWayBillVehicleList() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfEWayBillVehicle",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.EWayBillVehicleList.push(...response);
            //console.log("ewayBillList", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data!", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Getting List Of Pending Arrival Vehicle List     Created By Pawan Darji on 23/1/2020
  GetListOfPendingArrival() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfPendingArrival",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.PendingArrivalList.push(...response);
            console.log("pendingArrivalList", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Getting List Of Destination Gated In Vehicle List     Created By Pawan Darji on 23/1/2020
  GetListOfDestinationGateIn() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfDestinationGateIn",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.DestinationGatedIn.push(...response);
            //console.log("destinationGateIn", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Getting List Of Destinationgated Out Vehicle List      Created By Pawan Darji on 23/1/2020
  GetListOfDestinationGatedOut() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfDestinationGatedOut",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.DestinationGatedOut.push(...response);
            //console.log("destinaionGateOut", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Getting List Of Confirm Delivery Vehicle List     Created By Pawan Darji on 23/1/2020
  GetListOfConfirmDelivery() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfConfirmDelivery",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.ConfrimDelivery.push(...response);
            //console.log("confirmDelivery", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }
  //Ends Here

  //Getting List of Completed Delivery Vehicle List    Created By pAWAN dARJI ON 23/1/2020
  GetListOfCompleted() {
    this.clearData(); //Here clearing data in array
    this.flag = true;
    setTimeout(() => {
      this._appService
        .GetByThreeId(
          "Dashboard",
          "GetListOfCompleted",
          this.CompanyId,
          this.param1,
          this.userId
        )
        .subscribe(
          (response) => {
            this.flag = false;
            this.CompletedList.push(...response);
            //console.log("completedList", response);
          },
          (err) => {
            this.toastr.error("Error Occured While Fetching Data", "error");
          }
        );
    }, 1000);
  }

  //Getting Values and Assiging here
  MarkAssigned(FCNumber, FromCity, ToCity, VehicleType) {
    this.fcnumber = FCNumber;
    this.fromcity = FromCity;
    this.tocity = ToCity;
    this.vehicletype = VehicleType;
  }
}
